// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-activator[data-v-3a0fa288]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
